export default __webpack_public_path__ + "static/media/Number-plate.6a08bf82.jpg";